import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.div`
  & {
    color: ${({ theme }) => theme.colors.secondary[900]};
    outline: none;
    border: none;
    line-height: 1.75;
    font-size: var(--fs-500);
    font-weight: 300;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: row nowrap;
  }

  svg {
    flex: 0 0 25px;
    margin: 6px 6px 6px 0;
  }

  & > section {
    margin: 0 19px;
  }

  strong,
  b,
  span {
    font-weight: 500;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '&': {
          fontSize: [
            'var(--fs-300)',
            'var(--fs-300)',
            'var(--fs-500)',
            'var(--fs-500)',
          ],
        },
        svg: {
          margin: [
            '4px 4px 4px 0',
            '4px 4px 4px 0',
            '6px 6px 6px 0',
            '6px 6px 6px 0',
          ],
        },
      }),
    ).styles}}
`

export default Container
